module.exports = __webpack_public_path__ + "static/img/icon-back.c5651ff9.png";